<span class="description">
  {{ 'AUTOMATIONS.EDITOR.TRIGGERS.INIT_SUBSCRIPTION_TIER_UPDATE.PARTNER_SUBSCRIPTION_TIER_CHANGE' | translate }}
</span>
